import { render, staticRenderFns } from "./GameProjectList.vue?vue&type=template&id=31aa6ec5"
import script from "./GameProjectList.vue?vue&type=script&lang=js"
export * from "./GameProjectList.vue?vue&type=script&lang=js"
import style0 from "./GameProjectList.vue?vue&type=style&index=0&id=31aa6ec5&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports